import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import { Input, Button, Spin, Alert } from 'antd';

import { api } from '../../../../services';

import TelephoneIcon from '../../../../common/icons/SupportIcons/TelephoneIcon';
import EnvelopeIcon from '../../../../common/icons/SupportIcons/EnvelopeIcon';

import './SupportView.css';

import { observer, inject } from 'mobx-react';

const { TextArea } = Input;

@withRouter
@inject('translationsStore', 'communicationsStore')
@observer
class SupportView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      supportModalActionDone: false,
      supportModalEmailBody: '',
      supportModalEmailSending: false,
      supportModalEmailErrorBody: false,
      supportModalEmailErrorSending: false
    };
    this.textInput = React.createRef();
  }

  handleTelephoneSupport = () => {
    const {
      onSelectKey,
      channels: { phone }
    } = this.props;

    onSelectKey instanceof Function && onSelectKey('phone');

    setTimeout(function() {
      window.location = `tel:${phone}`;
    }, 500);
  };

  handleEmailSupport = () => {
    const { onSelectKey } = this.props;

    onSelectKey instanceof Function && onSelectKey('email');
  };

  handleSupportModalEmailSend = () => {
    if (this.state.supportModalEmailBody === '') {
      this.setState({
        supportModalEmailErrorBody: true
      });
    } else {
      const { translationsStore } = this.props;
      const [subject, message] = [translationsStore.translate('header.support.emailView.emailSubject'), this.state.supportModalEmailBody];
      this.setState({
        supportModalEmailSending: true,
        supportModalEmailErrorBody: false,
        supportModalEmailErrorSending: false
      });
      api('supportRequest', subject, message)
        .then(() => {
          this.setState({
            supportModalEmailErrorSending: false,
            supportModalActionDone: true
          });
        })
        .catch(() => {
          this.setState({
            supportModalEmailErrorSending: true
          });
        })
        .finally(() => {
          this.setState({
            supportModalEmailSending: false
          });
        });
    }
  };

  onSupportModalEmailBodyChange = e => {
    this.setState({
      supportModalEmailBody: e.target.value,
      supportModalEmailErrorBody: false
    });
  };

  render() {
    const {
      translationsStore,
      channels: { phone, email },
      supportKey
    } = this.props;

    let supportModalViewOffset = 0;
    switch (supportKey) {
      case 'phone':
        supportModalViewOffset = 0;
        break;
      case 'email':
        supportModalViewOffset = -520;
        break;
      // no default
    }

    return (
      <div className="SupportModalWrapper">
        <div className="SupportModalContainer" style={{ width: '200%', marginLeft: supportModalViewOffset }}>
          <div className="SupportModal SupportModalMainView">
            <div className="SupportModalMainViewPane">
              <div style={{ textAlign: 'center', fontSize: 48 }} onClick={this.handleTelephoneSupport}>
                <TelephoneIcon />
              </div>
              <div style={{ textAlign: 'center' }} onClick={this.handleTelephoneSupport}>
                {translationsStore.translate('header.support.telephoneLabel')}
                <br />
                <span style={{ fontWeight: 'bold' }} className="supportCellValue">
                  {phone}
                </span>
              </div>
              <Button className="MainViewButton" disabled={!isMobile} type="primary" size="small" onClick={this.handleTelephoneSupport}>
                {translationsStore.translate('header.support.telephoneAction')}
              </Button>
              {!isMobile && <div className="MainViewSubscript">{translationsStore.translate('header.support.telephoneDirectCallReminder')}</div>}
            </div>
            <div className="SupportModalMainViewPane">
              <div style={{ textAlign: 'center', fontSize: 48 }} onClick={this.handleEmailSupport}>
                <EnvelopeIcon />
              </div>
              <div style={{ textAlign: 'center' }} onClick={this.handleEmailSupport}>
                {translationsStore.translate('header.support.emailLabel')}
                <br />
                <span style={{ fontWeight: 'bold' }} className="supportCellValue">
                  {email}
                </span>
              </div>
              <Button className="MainViewButton" type="primary" size="small" onClick={this.handleEmailSupport}>
                {translationsStore.translate('header.support.emailAction')}
              </Button>
            </div>
          </div>
          <div className="SupportModal SupportModalEmailView">
            <Fragment>
              <div style={{ fontWeight: 'bold', marginBottom: 20 }}>
                <EnvelopeIcon /> {translationsStore.translate('header.support.emailView.intro')}
              </div>
              {!this.state.supportModalActionDone && (
                <Spin spinning={this.state.supportModalEmailSending}>
                  <TextArea value={this.state.supportModalEmailBody} onChange={this.onSupportModalEmailBodyChange} rows={3} style={{ resize: 'none', marginBottom: 40 }} />
                  {!!this.state.supportModalEmailErrorBody && (
                    <Alert message={translationsStore.translate('header.support.emailView.errorEmailCheckBody')} type="error" style={{ marginBottom: 20 }} />
                  )}
                  {!!this.state.supportModalEmailErrorSending && (
                    <Alert message={translationsStore.translate('header.support.emailView.errorEmailCannotSend')} type="error" style={{ marginBottom: 20 }} />
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button type="primary" onClick={this.handleSupportModalEmailSend}>
                      {translationsStore.translate('header.support.emailView.buttonSend')}
                    </Button>
                  </div>
                </Spin>
              )}
              {!!this.state.supportModalActionDone && (
                <Fragment>
                  <div style={{ marginBottom: 40 }}>{translationsStore.translate('header.support.emailView.labelEmailSentText')}</div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Button type="primary" onClick={this.props.onOk}>
                      {translationsStore.translate('header.support.emailView.labelEmailSentDone')}
                    </Button>
                  </div>
                </Fragment>
              )}
            </Fragment>
          </div>
        </div>
      </div>
    );
  }
}

export default SupportView;
